export default "__VITE_ASSET__45959b17__"